export function parsePostTypeSelection(value) {
	try {
		const parsed = JSON.parse(value);

		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
}

export function normalizePostTypeLabels(value) {
	return value && typeof value === 'object' && !Array.isArray(value)
		? value
		: {};
}

export function updatePostTypeLabel(labels, postType, value) {
	const updated = { ...normalizePostTypeLabels(labels) };

	if (!postType) {
		return updated;
	}

	if (value.trim().length > 0) {
		updated[postType] = value;
	} else {
		delete updated[postType];
	}

	return updated;
}
